import {
  createScheduledActions,
  ScheduledActions,
  SB,
  ReplicantEventHandlerAPI,
} from '@play-co/replicant';
import type { ReplicantSyncActionAPI } from '@play-co/replicant';
import { ReplicantFromState, stateSchema } from '../../State';
import computedProperties from '../computedProperties';
import messages from '../messages';
import asyncGetters from '../asyncGetters';
import ab from '../../ruleset/ab';

export type ScheduledActionAPI = ReplicantEventHandlerAPI<
  ReplicantFromState<typeof config>
>;

// Helper for defining module scheduled actions
const config = {
  ruleset: { abTests: ab.dynamicAB },
  computedProperties,
  messages,
  asyncGetters,
};
export default <T extends Record<string, SB.Schema>>(schema: T) =>
  createScheduledActions(stateSchema, schema, config);

type ScheduledActionHandlers<TScheduledActions extends ScheduledActions> = {
  [K in keyof TScheduledActions]: TScheduledActions[K]['action'];
};

export const extractScheduledActionHandlers = <
  TScheduledActions extends ScheduledActions,
>(
  actions: TScheduledActions,
) =>
  Object.entries(actions).reduce(
    (actions, [name, { action }]) => ({
      ...actions,
      [name]: action,
    }),
    {} as ScheduledActionHandlers<TScheduledActions>,
  );
